import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'

export enum EventRoutesEnum {
    ShowEvent = '/produtos/eventos/:id',
    DatatableClosureAutomation = '/event/fechamento/automatizados',
    ShowClosureAutomation = '/event/fechamento/automatizados/:id',
}

export function EventRoutes() {
    /*Rotas para Cartoes coringa*/
    const DatatableCardJokers = lazy(
        () => import('../../pages/event/card_jokers/DatatableCardJokers')
    )

    /*Rotas para Cartões não utilizados*/
    const DatatableCardsNotUsed = lazy(
        () => import('../../pages/event/utilities/cards_not_used/DatatableCardsNotUsed')
    )

    /*Rotas para Resumo*/
    const DatatableEventReportSummary = lazy(
        () => import('../../pages/event/reports/DatatableEventReportSummary')
    )

    /*Rotas para Resumo*/
    const DatatableFowardPending = lazy(
        () => import('../../pages/event/forward/pending/DatatableFowardPending')
    )

    /*Rotas para Fechamento*/
    const DatatableClosureAutomation = lazy(
        () => import('../../pages/event/closures/automation/DatatableClosureAutomation')
    )
    const ShowClosureAutomation = lazy(
        () => import('../../pages/event/closures/automation/ShowClosureAutomation')
    )

    /*Rotas para Pré-Evento*/
    const DatatablePreEvent = lazy(() => import('../../pages/event/pre_events/DatatablePreEvent'))
    const StorePreEvent = lazy(() => import('../../pages/event/pre_events/StorePreEvent'))
    const ShowPreEvent = lazy(() => import('../../pages/event/pre_events/ShowPreEvent'))

    /*Rotas para o Dashboard Financeiro*/
    const ManagementClosureDashboard = lazy(
        () => import('../../pages/dashboard/components/financial/management/ManagementClosureDashboard')
    )
    const OperationalClosureDashboard = lazy(
        () => import('../../pages/dashboard/components/financial/operational/OperationalClosureDashboard')
    )

    return (
        <Switch>
            {/*Rotas para Cartões não utilizados*/}
            <Route path='/event/utilidades/cartoes-nao-usados' component={DatatableCardsNotUsed} />

            {/*Rotas para Resumo*/}
            <Route path='/event/cartoes-coringa' component={DatatableCardJokers} />

            {/*Rotas para Resumo*/}
            <Route path='/event/relatorios/resumo' component={DatatableEventReportSummary} />

            {/*Rotas para Resumo*/}
            <Route path='/event/repasse/pendentes' component={DatatableFowardPending} />

            {/*Rotas para Fechamento*/}
            <Route path={EventRoutesEnum.ShowClosureAutomation} component={ShowClosureAutomation} />
            <Route
                path={EventRoutesEnum.DatatableClosureAutomation}
                component={DatatableClosureAutomation}
            />

            {/*Rotas para Pré-Evento*/}
            <Route path='/event/pre-eventos/cadastrar' component={StorePreEvent} />
            <Route path='/event/pre-eventos/:id' component={ShowPreEvent} />
            <Route path='/event/pre-eventos' component={DatatablePreEvent} />

            {/*Rotas para o Dashboard Financeiro*/}
            <Route path='/event/dashboard/gestao' component={ManagementClosureDashboard} />
            <Route path='/event/dashboard/operacional' component={OperationalClosureDashboard} />
        </Switch>
    )
}
